import { ReactNode } from "react"

interface MoveContentToRightProps {
    children: ReactNode
}

function MoveContentToRight(props: MoveContentToRightProps) {
    return <div className={"ml-auto"}>{props.children}</div>
}

export default MoveContentToRight
